<template>
    <div class="grant-drawer">
        <el-drawer :title="grantDrawer.title" :visible.sync="grantDrawer.visible" size="45%" direction="rtl" :before-close="closeDrawer">
            <div class="drawer-form">
                <el-form :model="grantForm" :rules="grantFormRules" ref="grantForm" label-width="100px" label-position="left">
                    <el-form-item label="扩展部门" prop="show_visit_log">
                        <el-tree show-checkbox ref="departmentTree" :data="departmentTree" node-key="id" :expand-on-click-node="false" highlight-current :check-strictly="true" :default-checked-keys="treeChecked" :default-expanded-keys="treeChecked">
                            <div class="custom-tree-node" slot-scope="{ node }">
                                <span>{{ node.label }}</span>
                            </div>
                        </el-tree>
                    </el-form-item>

                    <el-form-item label="查看所有回访" prop="show_visit_log">
                        <el-radio-group v-model="grantForm.show_visit_log" class="radio-group">
                            <el-radio label="1">是</el-radio>
                            <el-radio label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-divider content-position="center">微信聊天记录权限</el-divider>
                    <div class="grant-item">
                        <el-checkbox-group v-model="wechatForm.state" @change="wechatChange">
                            <el-checkbox v-for="(item,index) in wechatList" :label="item.id" :key="index">
                                <el-tooltip effect="dark" :content="item.label" placement="top">
                                    <span>{{ item.label }}</span>
                                </el-tooltip>
                            </el-checkbox>
                        </el-checkbox-group>
                        <el-form-item v-if="wechatForm.state.includes(3)" label="查看指定部门" prop="department_id">
                            <el-tree show-checkbox ref="departmentTreeWechat" :data="departmentTree" node-key="id" :expand-on-click-node="false" highlight-current :check-strictly="true" :default-checked-keys="treeWechatChecked" :default-expanded-keys="treeWechatChecked">
                                <div class="custom-tree-node" slot-scope="{ node }">
                                    <span>{{ node.label }}</span>
                                </div>
                            </el-tree>
                        </el-form-item>
                        <el-form-item v-if="wechatForm.state.includes(4)" label="查看指定用户" prop="users">
                            <picker-user v-model="wechatForm.user_id" placeholder="指定用户"></picker-user>
                        </el-form-item>
                    </div>
                    <el-divider content-position="center">服务城市权限</el-divider>
                    <div class="grant-item">
                        <el-checkbox-group v-model="grantForm.cities">
                            <el-checkbox v-for="city in cityList" :label="city.id + ''" :key="city.id">
                                <el-tooltip effect="dark" :content="city.title" placement="top">
                                    <span>{{ city.title }}</span>
                                </el-tooltip>
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>

                    <el-divider content-position="center">订单公司权限</el-divider>
                    <div class="grant-item">
                        <el-checkbox-group v-model="grantForm.company_ids">
                            <el-checkbox class="check-item" v-for="company in companyList" :label="company.id + ''" :key="company.id">
                                <el-tooltip v-if="company.title.length > 8" effect="dark" :content="company.title" placement="top">
                                    <span>{{ company.title.length > 8 ? company.title.substring(0, 8) + '...' : company.title }}</span>
                                </el-tooltip>
                                <span v-else>{{ company.title.length > 8 ? company.title.substring(0, 8) + '...' : company.title }}</span>
                            </el-checkbox>
                        </el-checkbox-group>
                        <div class="grant-item-more">
                            <el-button type="primary" size="mini" @click="appliedTo">应用于</el-button>
                        </div>
                        <!-- 已选择的页面 -->
                        <div class="applied-box" v-if="appliedPage.length > 0">
                            <el-divider content-position="center">已选应用页面</el-divider>
                            <div class="applied-page">
                                <div class="applied-item" v-for="(item, index) in appliedPage" :key="index">
                                    <el-tag>{{ item.title }}</el-tag>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 应用于页面弹窗 -->
                    <div class="applied-dialog">
                        <el-dialog title="应用页面" :visible.sync="dialog.visible" :append-to-body="true" :before-close="closeDialog">
                            <el-divider content-position="center">客资管理</el-divider>
                            <div class="grant-item">
                                <el-checkbox-group v-model="applied" @change="appliedChange">
                                    <el-checkbox class="check-item" v-for="item in customerList" :label="item.name" :key="item.name">
                                        <span>{{ item.title }}</span></el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <el-divider content-position="center">订单管理</el-divider>
                            <div class="grant-item">
                                <el-checkbox-group v-model="applied" @change="appliedChange">
                                    <el-checkbox class="check-item" v-for="item in orderList" :label="item.name" :key="item.name">
                                        <span>{{ item.title }}</span></el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <el-divider content-position="center">订单审核</el-divider>
                            <div class="grant-item">
                                <el-checkbox-group v-model="applied" @change="appliedChange">
                                    <el-checkbox class="check-item" v-for="item in confirmList" :label="item.name" :key="item.name">
                                        <span>{{ item.title }}</span></el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <el-divider content-position="center">财务统计</el-divider>
                            <div class="grant-item">
                                <el-checkbox-group v-model="applied" @change="appliedChange">
                                    <el-checkbox class="check-item" v-for="item in fianceList" :label="item.name" :key="item.name">
                                        <span>{{ item.title }}</span></el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div slot="footer" class="dialog-footer">
                                <el-button @click="closeDialog">取 消</el-button>
                                <el-button type="primary" @click="confirm">确 定</el-button>
                            </div>
                        </el-dialog>
                    </div>

                    <el-divider content-position="center">策划门店权限</el-divider>
                    <div class="grant-item">
                        <el-checkbox-group v-model="grantForm.store_ids">
                            <el-checkbox class="check-item" v-for="store in companyList" :label="store.id + ''" :key="store.id">
                                <el-tooltip v-if="store.title.length > 8" effect="dark" :content="store.title" placement="top">
                                    <span>{{ store.title.length > 8 ? store.title.substring(0, 8) + '...' : store.title }}</span>
                                </el-tooltip>
                                <span v-else>{{ store.title.length > 8 ? store.title.substring(0, 8) + '...' : store.title }}</span>
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-form>

                <div class="grant-footer">
                    <el-button type="primary" @click="saveGrantDrawer">保存</el-button>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import pickerUser from '@/components/picker/user.vue'
const wechatForm = {
    state: [],
    department_ids: '',
    user_id: [], // 权限城市

}
export default {
    props: {
        cityList: {
            type: Array,
            default: []
        },
        companyList: {
            type: Array,
            default: []
        }
    },
    components: {
        pickerUser,
    },
    data() {
        return {
            wechatForm: Object.assign({}, wechatForm),
            grantDrawer: {
                title: '用户授权',
                visible: false,
                method: 'create'
            },

            dialog: {
                title: '',
                visible: false
            },
            wechatList: [{
                id: 1,
                label: '可看自己'
            }, {
                id: 2,
                label: '看同部门'
            }, {
                id: 3,
                label: '看指定部门'
            }, {
                id: 4,
                label: '看指定用户'
            }],
            departmentTree: [{
                id: 1,
                label: '一级 1'
            }],
            treeChecked: [],
            treeWechatChecked: [],

            applied: [], // 已选中的页面路径(传参用)
            appliedPage: [], // 已选中的页面名称(渲染用)
            // 客资列表
            customerList: [{
                name: '/customer/today',
                title: '今日跟进'
            },
            {
                name: '/customer/mine',
                title: '我的客资'
            },
            {
                name: '/customer/dispatch',
                title: '派单客资'
            },
            {
                name: '/customer/all',
                title: '所有客资'
            },
            {
                name: '/customer/sea',
                title: '客资公海'
            },
            {
                name: '/customer/recycle',
                title: '回收站'
            },
            {
                name: '/customer/import',
                title: '导入客资'
            }
            ],
            // 订单列表
            orderList: [{
                name: '/order/order/all',
                title: '所有订单'
            },
            {
                name: '/order/order/mine',
                title: '我的订单'
            },
            {
                name: '/order/order/refund',
                title: '退单订单'
            },
            {
                name: '/order/order/abrogate',
                title: '作废订单'
            },
            {
                name: '/order/order/number',
                title: '订单号管理'
            },
            {
                name: '/order/order/settlement',
                title: '结算单'
            }
            ],
            // 订单审核列表
            confirmList: [{
                name: '/confirm/confirm/all',
                title: '所有审核'
            },
            {
                name: '/confirm/confirm/mine',
                title: '我的审核'
            },
            {
                name: '/confirm/confirm/settlement',
                title: '结算单审核'
            },
            {
                name: '/confirm/confirm/unchecked',
                title: '待审核'
            },
            {
                name: '/confirm/confirm/accept',
                title: '审核通过'
            },
            {
                name: '/confirm/confirm/reject',
                title: '审核驳回'
            }
            ],
            // 财务统计列表
            fianceList: [{
                name: '/statistics/fiance/income_reality',
                title: '资金收款报表'
            },
            {
                name: '/statistics/fiance/income_shalt',
                title: '应收账款报表'
            },
            {
                name: '/statistics/fiance/payment_shalt',
                title: '应付账款报表'
            },
            {
                name: '/statistics/fiance/held',
                title: '本月举办完成'
            },
            {
                name: '/statistics/fiance/index',
                title: '集团所有订单'
            },
            {
                name: '/profit/all',
                title: '利润预估'
            },
            {
                name: '/statistics/fiance/wedding_suborder',
                title: '婚庆版块签定增项'
            },
            {
                name: '/statistics/fiance/banquet',
                title: '集团婚宴版块定单表'
            },
            {
                name: '/statistics/fiance/wedding',
                title: '集团婚庆版块定单'
            },
            {
                name: '/statistics/fiance/settlement',
                title: '结算单报表'
            }
            ],

            grantForm: {
                user_id: '',
                department_id: '',
                show_visit_log: 0, // 是否可查看回访
                cities: [], // 权限城市
                company_ids: [], // 订单权限
                store_ids: [] // 策划权限
            },
            grantFormRules: {}
        };
    },
    methods: {
        wechatChange() {
            console.log(this.wechatForm.state)
            console.log(typeof this.wechatForm.state)
        },
        showGrantDrawer(row) {
            let that = this;
            console.log(row)
            that.grantDrawer.visible = true;
            that.grantForm.user_id = row.id;
            that.readUserAuth();
            that.getDepartmentTree();
        },

        // 读取用户权限
        readUserAuth() {
            let that = this;
            let params = {
                user_id: that.grantForm.user_id
            };
            let url = '/api/ucenter.grant/readAuth';
            that.$post(url, params).then(function (res) {
                if (res.code == 200) {
                    let row = res.data.row;
                    if (row.length != 0) {
                        that.grantForm.show_visit_log = row.show_visit_log + '';
                        that.grantForm.cities = row.cities;
                        that.treeChecked = row.department_ids;
                        that.grantForm.company_ids = row.company_ids;
                        that.grantForm.store_ids = row.store_ids;
                        that.appliedPage = row.company_page;
                        that.appliedPage.forEach(item => {
                            that.applied.push(item.name)
                        });
                    }
                } else {
                    that.$message.error(res.msg);
                }
            });
        },

        // 获取部门树
        getDepartmentTree() {
            let that = this;
            let url = '/api/ucenter.department/getUserDepartmentTree';
            that.$post(url).then(function (res) {
                if (res.code == 200) {
                    that.departmentTree = res.data.tree;
                } else {
                    that.$message.error(res.msg);
                }
            });
        },

        // 清空
        closeDrawer() {
            this.grantForm = {
                user_id: '',
                department_id: '',
                show_visit_log: 0, // 是否可查看回访
                cities: [], // 权限城市
                company_ids: [], // 订单权限
                store_ids: [] // 策划权限
            };
            this.applied = [];
            this.appliedPage = [];
            this.grantDrawer.visible = false;
        },

        // 订单公司权限应用页面
        appliedTo() {
            this.dialog.visible = true;
        },
        // 关闭
        closeDialog() {
            this.dialog.visible = false;
        },
        // 确认提交
        confirm() {
            this.closeDialog();
        },
        // 页面权限发生改变
        appliedChange() {
            let applied = this.applied;
            let customerList = this.customerList;
            let customerPage = [];
            let orderList = this.orderList;
            let orderPage = [];
            let confirmList = this.confirmList;
            let confirmPage = [];
            let fianceList = this.fianceList;
            let fiancePage = [];
            applied.forEach((item) => {
                customerList.forEach((customer) => {
                    if (customer['name'].includes(item)) {
                        customerPage.push({
                            name: customer['name'],
                            title: customer['title']
                        });
                    }
                });
                orderList.forEach((order) => {
                    if (order['name'].includes(item)) {
                        orderPage.push({
                            name: order['name'],
                            title: order['title']
                        });
                    }
                });
                confirmList.forEach((confirm) => {
                    if (confirm['name'].includes(item)) {
                        confirmPage.push({
                            name: confirm['name'],
                            title: confirm['title']
                        });
                    }
                });
                fianceList.forEach((fiance) => {
                    if (fiance['name'].includes(item)) {
                        fiancePage.push({
                            name: fiance['name'],
                            title: fiance['title']
                        });
                    }
                });
            });
            this.appliedPage = [...customerPage, ...orderPage, ...confirmPage, ...fiancePage];
        },

        // 提交
        saveGrantDrawer() {
            let that = this;
            let params = Object.assign(
                that.grantForm, {
                company_page: that.appliedPage
            }, {
                department_ids: that.$refs['departmentTree'].getCheckedKeys()
            }
            );
            let url = '/api/ucenter.grant/bindAuth';
            that.$post(url, params).then(function (res) {
                if (res.code == 200) {
                    that.$message.success(res.msg);
                    that.closeDrawer();
                    that.$emit('getTableData');
                } else {
                    that.$message.error(res.msg);
                }
            });
        }
    }
};
</script>

<style lang="less">
@import url('@/assets/css/drawer.less');

.check-item .el-checkbox__label {
    width: 100px;
    font-size: 14px;
    text-overflow: ellipsis;
}

.applied-box .applied-page {
    display: flex;
    flex-wrap: wrap;
}

.applied-page .applied-item {
    margin-bottom: 10px;
    flex: 0 25%;
}

.grant-item .el-checkbox-group {
    line-height: 30px;
}

.grant-item-more {
    text-align: center;
}

.grant-footer {
    position: sticky;
    bottom: 0;
    padding: 10px 0;
    text-align: center;
    background: #fff;
    z-index: 1;
}
</style>
